import {useEffect, useState} from "react";

type Size = {
    width: number;
    height: number;
};

export const useElementSize = (ref: React.RefObject<HTMLElement>) => {
    const [size, setSize] = useState<Size>({width: 0, height: 0});

    useEffect(() => {
        if (!ref.current) {
            return;
        }
        const element = ref.current;
        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (!entry) {
                return;
            }
            const {width, height} = entry.contentRect;
            setSize({width, height});
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, [ref]);

    return size;
};
